import React, {useEffect} from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert, Spinner } from 'react-bootstrap'
import useStores from '../../../stores/useStore'
import EditReceiptSubheader from '../../../components/LocalReceipts/EditReceipts/EditReceiptSubheader'
import EditReceiptSidebar from '../../../components/LocalReceipts/EditReceipts/EditReceiptSidebar'
import EditReceiptContentArea from '../../../components/LocalReceipts/EditReceipts/EditReceiptContentArea'
import { StyledGoodReceiptsContainer } from '../../../components/LocalReceipts/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../../components/Footer/BigFooter'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import LocalReceiptDataProvider, { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'
import { useParams } from 'react-router-dom'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`
const EditGoodsReceiptPageContent = () => {
    const { receiptId } = useParams()
    const { loadReceiptData} = useLocalReceiptDataState()
    
    useEffect(() => {
      const init = async () => {
        loadReceiptData(receiptId, 'edit')
      }
      init()
    }, [receiptId, loadReceiptData])
  
    return (
        <>
        <EditReceiptSubheader />
        <FlexWrapper>
          <StyledContentArea>
            <EditReceiptContentArea />
          </StyledContentArea>
          <TestSidebarRight>
            <EditReceiptSidebar />
          </TestSidebarRight>
        </FlexWrapper>
        <BigFooter />
      </>
    )
  }
  
  const EditGoodsReceiptPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()
    const dashboardLoaded = useObserver(() => !!uiStore.dashboard)
  
  
    return useObserver(() => (
      <LocalReceiptDataProvider>
        <StyledGoodReceiptsContainer>
          {!dashboardLoaded || !uiStore.isLocalStorageAdmin
            ? (
              <FlexWrapper>
                <StyledContentArea>
                  {dashboardLoaded
                    ? <Alert variant="danger">{t('goodsReceiptPage:editReceiptAlert')}</Alert>
                    : <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                  }
                </StyledContentArea>
                <TestSidebarRight>
                </TestSidebarRight>
              </FlexWrapper>)
            :
            <EditGoodsReceiptPageContent />
          }
          <BigFooter />
        </StyledGoodReceiptsContainer>
      </LocalReceiptDataProvider>
    ))
  }
  
  export default EditGoodsReceiptPage
  